import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { DishCreateNamePage } from '../../../dish/dish-create/dish-create-name/dish-create-name';

@Component({
  selector: 'page-tutorial-dishes',
  templateUrl: 'tutorial-dishes.html',
})
export class TutorialDishesPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public dishServices: DishServices) {

  }

  close() {
    /*this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_dish': true,
    }).then(() => {
      this.navCtrl.pop();
    });*/
    this.navCtrl.pop();
  }

  createDish() {
    var total_dishes = 0;
    if (this.dishServices._dishes_array_tmp) {
      total_dishes = this.dishServices._dishes_array_tmp.length;
    }
    //Si total_dishes es mayor o igual al limite de platos, y el limite es diferente a -1
    if (total_dishes >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
      this.navCtrl.pop();
    } else {
      this.dishServices.image_url_dish_view = null;
      //
      this.globals.tourLaunchStep(2);
      //
      this.navCtrl.push(DishCreateNamePage, {
        update: false
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-dishes/tutorial-dishes.ts